<div (click)="onMapContainerSelected()" [ngClass]="{ 'active-map': isMapSelected }"
     class="map-container mat-mdc-card-outlined">
    <p *ngIf="upperLabel" class="upper-label">
        {{ upperLabel }}
    </p>
    <div #svgElContainer [ngStyle]="wrapperDimensions" cardioMap class="vista-container">
        <svg [attr.id]="map?.viewId || 'map'"
             anatomicMapDirective
             font-size="24px"
             height="100%"
             viewBox="0 0 500 500"
             width="100%"
             xmlns="http://www.w3.org/2000/svg">

            <defs *ngIf="!!map?.vectaVersion">
                <pattern height="20" id="obl1" patternUnits="userSpaceOnUse" width="20" x="0" y="0">
                    <line stroke="red" x1="20" x2="0" y1="0" y2="20" />
                </pattern>
                <pattern height="20" id="obl2" patternUnits="userSpaceOnUse" width="20" x="0" y="0">
                    <line stroke="red" x1="0" x2="20" y1="0" y2="20" />
                </pattern>
                <pattern height="20" id="grid1" patternUnits="userSpaceOnUse" width="20" x="0" y="0">
                    <line stroke="red" x1="20" x2="0" y1="0" y2="20" />
                    <line stroke="red" x1="0" x2="20" y1="0" y2="20" />
                </pattern>
            </defs>
            <rect [attr.fill]="boardFill" height="100%" width="100%"></rect>
            <text *ngIf="!map" fill="black" stroke="black" x="200" y="250">No Map Loaded</text>
            <image *ngIf="map && map.pathImg" [attr.href]="map.pathImg" height="100%" onerror="this.style.display='none'"
                   onload="this.style.display='initial'" width="100%" />
        </svg>
    </div>
    <p *ngIf="lowerLabel" class="lower-label">{{ lowerLabel }}</p>
    <p *ngIf="isWithViewId && map?.viewId" class="map-id-label">{{ 'ViewLabel' | translate }}: {{ map?.viewId }}</p>
    <p *ngIf="isWithStageName && map?.stageDescription" class="map-id-label">{{ 'StageLabel' | translate }}
        : {{ map?.stageDescription }}</p>
</div>
